import ActionTypes from '../../../constants/ActionTypes';
import { IHideMobileMenuAction, ISetMenuItemsAction, IShowMobileMenuAction } from "./types";
import { Dispatch } from 'redux';

export function setMenuItemsAction(
  items: object[],
  visible: boolean,
  isLogin: boolean,
  id: number,
): ISetMenuItemsAction {
  return {
    type: ActionTypes.MENU.SET_ITEMS,
    payload: {
      items,
      visible,
      isLogin,
      id,
    },
  };
}

export const hideMobileSubmenuItemsActions = () => (dispatch: Dispatch)  => {
  return dispatch({
    type: ActionTypes.MENU.HIDE_MOBILE_SUBMENU_ITEMS,
    payload: false,
  });
};

export const showMobileMenuAction = () => (dispatch: Dispatch) : IShowMobileMenuAction => {
  return dispatch({
    type: ActionTypes.MENU.SHOW_MOBILE
  });
};

export const hideMobileMenuAction = () => (dispatch: Dispatch) : IHideMobileMenuAction => {
  return dispatch({
    type: ActionTypes.MENU.HIDE_MOBILE
  });
};
